import { NgModule } from '@angular/core';
import { AddressTypePipe } from './address-type.pipe';
import { AddressPipe } from './address.pipe';
import { DateTimePipe } from './date-time.pipe';
import { DisplayValuePipe } from './display-value.pipe';
import { DollarPipe } from './dollar.pipe';
import { ElapsedTimePipe } from './elapsed-time.pipe';
import { ExpirationPipe } from './expiration.pipe';
import { FinanceCurrencyPipe } from './finance-currency.pipe';
import { JurisdictionCodePipe } from './jurisdiction-code.pipe';
import { MonthNamePipe } from './month-name.pipe';
import { MonthYearPipe } from './month-year.pipe';
import { NumberCommaPipe } from './number-comma.pipe';
import { PaginationPipe } from './pagination.pipe';
import { PhoneNumberUSAPipe } from './phone-number-usa.pipe';
import { PhoneNumberUSAWithExtensionPipe } from './phone-number-usa-with-extension.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SecondsToDateTime } from './seconds-date-time.pipe';
import { ServerTimePipe } from './server-time.pipe';
import { ShortDatePipe } from './short-date.pipe';
import { YesNoPipe } from './yes-no.pipe';
import { ZipCodePipe } from './zip-code.pipe';
import { DateAgoPipe } from './date-ago.pipe';
import { InchesPipe } from './inches-pipe';
import { IRPJurisdictionCodePipe } from './irp-jurisdiction-code.pipe';
import { IFTAStatusCodePipe } from './ifta-status-code.pipe';
import { IRPStatusCodePipe } from './irp-status-code.pipe';
import { CreditDisplayPipe } from './credit-display.pipe';
import { DecimalPipe } from '@angular/common';
import { CVIEWYesNoPipe } from './cview-yes-no.pipe';
import { SafeResourceUrlPipe } from './safe-resource-url.pipe';
import { KeywordHighlighter } from './keyword-hightlighter.pipe';
import { TableDataLineBreakPipe } from './table-data-line-break.pipe';
import { TimePipe } from './time.pipe';
import { CountyCodePipe } from './county-code.pipe';
import { CountryCodePipe } from './country-code.pipe';
import { JsonFormatPipe } from './json-format.pipe';

@NgModule({
    declarations: [
        AddressPipe,
        AddressTypePipe,
        CountryCodePipe,
        CountyCodePipe,
        DateTimePipe,
        DisplayValuePipe,
        DollarPipe,
        ElapsedTimePipe,
        ExpirationPipe,
        FinanceCurrencyPipe,
        JurisdictionCodePipe,
        KeywordHighlighter,
        MonthNamePipe,
        MonthYearPipe,
        NumberCommaPipe,
        PaginationPipe,
        PhoneNumberUSAPipe,
        PhoneNumberUSAWithExtensionPipe,
        SafeHtmlPipe,
        SafeResourceUrlPipe,
        SecondsToDateTime,
        ServerTimePipe,
        ShortDatePipe,
        TimePipe,
        YesNoPipe,
        ZipCodePipe,
        CreditDisplayPipe,
        DateAgoPipe,
        InchesPipe,
        IRPJurisdictionCodePipe,
        IFTAStatusCodePipe,
        IRPStatusCodePipe,
        CVIEWYesNoPipe,
        TableDataLineBreakPipe,
        JsonFormatPipe
    ],
    exports: [
        AddressPipe,
        AddressTypePipe,
        CountryCodePipe,
        CountyCodePipe,
        DateTimePipe,
        DisplayValuePipe,
        DollarPipe,
        ElapsedTimePipe,
        ExpirationPipe,
        FinanceCurrencyPipe,
        JurisdictionCodePipe,
        KeywordHighlighter,
        MonthNamePipe,
        MonthYearPipe,
        NumberCommaPipe,
        PaginationPipe,
        PhoneNumberUSAPipe,
        PhoneNumberUSAWithExtensionPipe,
        SafeHtmlPipe,
        SafeResourceUrlPipe,
        SecondsToDateTime,
        ShortDatePipe,
        ServerTimePipe,
        TimePipe,
        YesNoPipe,
        ZipCodePipe,
        CreditDisplayPipe,
        DateAgoPipe,
        InchesPipe,
        IRPJurisdictionCodePipe,
        IFTAStatusCodePipe,
        IRPStatusCodePipe,
        CVIEWYesNoPipe,
        TableDataLineBreakPipe,
        JsonFormatPipe
    ],
    providers: [
        DecimalPipe
    ]
})
export class SharedPipesModule {
}
